import ButtonGroup, {ButtonGroupProps} from '@mui/material/ButtonGroup';

import {styled} from '@mui/material/styles';

export const CButtonGroup = styled(ButtonGroup)<ButtonGroupProps>(
  (/* { theme } */) => ({
  }),
);
